<template>
    <dashboard-layout>

      <template v-if="fetchDataLoading">
        <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>

      <div v-if="!withData">
        <div class="big-white-card2" style="overflow: hidden;">
      <div class="center-content2">
        <img class="custom-icon-size" src="@/components/img/Sales_Assests/businesscentericon.svg" alt="Custom Icon">
        <p class="write-up">
          No Merchants onboarded under you
        </p>
        <div class="subhead-text2">You are yet to onboard a business under your profile. After</div>
        <div class="subhead-text2">onboarding a business,it will be listed here.</div>

        <button class="onboard-button" @click="openOnboardingModal0">Onboard A Merchant</button>
      </div>
      </div>
    </div>
    <div v-else>
      <div class="head-text3">Merchants</div>
    <div class="subhead-text3">All merchants you onboarded will be listed here.</div>
    <div class="big-card" style="overflow: hidden;">
      <div class="horizontal-container">
        <!-- Dropdown -->

        <div style="display: flex">
        <div class="dropdown-container">
              <select
                id="cardSwitch"
                class="form-control"
                v-model="cardSwitch"
                ref="dropdown"
                @change="handleCardSwitch"
                :disabled="disableDropdown"
                style="font-size: 12px; background-color: transparent;  cursor: pointer; z-index: 2; width: 120px; height: 35px;  color: #000; font-size: 13px; border: 1px solid #D1D5DB;"
              >
                <option value="Onboarded" selected>Onboarded</option>
                <option value="Pending">Pending</option>
              </select>
              <div v-if="cardSwitch == 'Onboarded' && pendingData.length != 0 || cardSwitch == 'Pending' && onboardedData.length != 0">
              <div class="dropdown-icon-container" >
                <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon" @click="toggleDropdown">
              </div>
            </div>
            </div>

        <!-- Search bar -->
        <div v-if="cardSwitch === 'Onboarded'">
        <div class="search-bar" style="margin-left: 10px;  max-width: 500px;">
        <div class="search-icon ">
          <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon" style="padding-right: 10px;">
        </div>
        <input type="text" class="form-control ml-1" v-model="searchTerm"  style="width: 370px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;" placeholder="  Search with merchant's ID, merchant's Name...">
      </div>
    </div>
    <div v-else>
      <div class="search-bar" style="margin-left: 10px;  max-width: 500px;">
        <div class="search-icon ">
          <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon" style="padding-right: 10px;">
        </div>
        <input type="text" class="form-control ml-1" v-model="searchTerm2"  style="width: 370px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;" placeholder="  Search with Business Name, Email...">
      </div>
    </div>
  </div>
        <!-- Onbaord Button-->
        <div class="button-container" style="margin-left: 210px; height: 35px; ">
          <button class="onboard-button2" @click="openOnboardingModal0">Onboard New Merchant</button>
        </div>
      </div><hr><hr>


      <div class="custom-table-container" :key="currentPage">
        
      <table class="custom-table">
        <thead>
          <tr>
            <th v-if="cardSwitch === 'Onboarded'">Date Created</th>
            <th v-if="cardSwitch === 'Onboarded'">Merchant's ID</th>
            <th v-if="cardSwitch === 'Onboarded'">Merchant's Name</th>
            <th v-if="cardSwitch === 'Onboarded'">Businesses</th>
            <th v-if="cardSwitch === 'Onboarded'">Locations</th>
            <th v-if="cardSwitch === 'Onboarded'">Cashiers</th>
            <!-- Additional columns for Pending data -->
            <th v-if="cardSwitch === 'Pending'">Date Started</th>
            <th v-if="cardSwitch === 'Pending'">Business Name</th>
            <th v-if="cardSwitch === 'Pending'">Email Address</th>
            <th v-if="cardSwitch === 'Pending'"></th>
            <th v-if="cardSwitch === 'Onboarded'"></th> 
          </tr>
        </thead>
        <tbody>
          <template v-if="filteredRows.length === 0">
        <tr>
          <td colspan="7" style="text-align: center;">No records found</td>
        </tr>
      </template>
          <template v-else-if="searchTerm && filteredRows.length > 0">
          <tr v-for="(row, index) in filteredRows" :key="index" class="table-row">
            <td>{{ row.dateCreated }}</td>
            <td>{{ row.merchantId }}</td>
            <td>{{ row.firstname }} {{ row.lastname }}</td>
            <td>{{ row.businessCount }}</td>
            <td>{{ row.locationCount }}</td>
            <td>{{ row.cashiersCount }}</td>
            <!-- Additional columns for Pending data -->
            <td v-if="cardSwitch === 'Pending'">{{ formatDate(row.DateCreated) }}</td>
            <td v-if="cardSwitch === 'Pending'">{{ row.BusinessName }}</td>
            <td v-if="cardSwitch === 'Pending'">{{ row.Email }}</td>
            <td v-if="cardSwitch === 'Pending'" 
            style="color: #6F48FF; 
            font-weight: bold; 
            cursor: pointer;"
            @click="openContinueModal(row)">Continue</td>
            <td class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab" v-show="row.showPopup">
                <router-link v-if="row.merchantId" :to="{ path: '/sales/business/details', query: { MID: row.merchantId } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View Details
                </router-link>
                <!-- <div class="divider"></div> -->
                <!-- <div  class="popup-item">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackplus.svg" 
                       alt="plus Icon" 
                       class="popup-icon"
                       style="height: 17px; width: auto;">
                  <img v-else src="@/components/img/Sales_Assests/colorplus.svg" 
                       alt="plus Icon" 
                       class="popup-icon"
                       style="height: 17px; width: auto;">
                  Add Business
                </div> -->
              </div>
            </td>
          </tr>
          </template>
          <template v-else>
           <tr v-for="(row, index) in visibleRows" :key="index" class="table-row" @click="navigateToDetails(row)">
            <td v-if="cardSwitch === 'Onboarded'">{{ row.dateCreated }}</td>
            <td v-if="cardSwitch === 'Onboarded'">{{ row.merchantId }}</td>
            <td v-if="cardSwitch === 'Onboarded'">{{ row.firstname }} {{ row.lastname }}</td>
            <td v-if="cardSwitch === 'Onboarded'">{{ row.businessCount }}</td>
            <td v-if="cardSwitch === 'Onboarded'">{{ row.locationCount }}</td>
            <td v-if="cardSwitch === 'Onboarded'">{{ row.cashiersCount }}</td>
            <td v-if="cardSwitch === 'Onboarded'" class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab" v-show="row.showPopup">
                <router-link v-if="row.merchantId" :to="{ path: '/sales/business/details', query: { MID: row.merchantId } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View Details
                </router-link>
                <!-- <div class="divider"></div>
                <div  class="popup-item">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackplus.svg" 
                       alt="plus Icon" 
                       class="popup-icon"
                       style="height: 17px; width: auto;">
                  <img v-else src="@/components/img/Sales_Assests/colorplus.svg" 
                       alt="plus Icon" 
                       class="popup-icon"
                       style="height: 17px; width: auto;">
                  Add Business
                </div> -->
              </div>
            </td>
             <!-- Additional columns for Pending data -->
             <td v-if="cardSwitch === 'Pending'">{{ formatDate(row.DateCreated) }}</td>
            <td v-if="cardSwitch === 'Pending'">{{ row.BusinessName }}</td>
            <td v-if="cardSwitch === 'Pending'">{{ row.Email }}</td>
            <td v-if="cardSwitch === 'Pending'" 
            style="color: #6F48FF; 
            font-weight: bold; 
            cursor: pointer;"
            @click="openContinueModal(row)">Continue</td>
          </tr>
        </template>

        </tbody>
      </table>
      <div class="pagination">
      <span>{{ currentPageStart }} - {{ currentPageEnd }} of {{ totalRows }}</span>
      <img src="@/components/img/Sales_Assests/previousbutton.svg" 
      class="pagination-icon1"
      alt="Prev Icon" 
      @click="prevPage">
      <img src="@/components/img/Sales_Assests/nextbutton.svg" 
      class="pagination-icon2"
      alt="Next Icon" 
      @click="nextPage">
    </div>
    <hr>
    </div>
      </div>
    </div>


    <onboarding-modal 
      :showOnboardingModal0="showOnboardingModal0" 
      :onboardButtonClicked="onboardButtonClicked" 
      :rowData="selectedRowData"
      @open-modal="openOnboardingModal0"  
      @close-modal="closeOnboardingModal0" 
      @close-modal1="closeOnboardingModal1" 
      @open-modal1="openOnboardingModal1"
      @continue-onboarding="openContinueModal"
      @reload-pending="fetchPendingOnboard"
      @reload-onboarded="fetchAllOnboardedMerchants"
    >
    </onboarding-modal>

  </template>




    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import OnboardingModal from './OnboardingModal.vue';
  // import ContinueOnboardingModal from './OnboardingModal.vue';
  import axios from 'axios'; 
  
  export default {
    name: 'sales-businesses',
  
    components: {
      DashboardLayout,
      OnboardingModal,
    },
  
    data() {
    return {

      showContinueModal: false,
      selectedRowData: null,
      fetchDataLoading: true,
      currentPage: 1,
      rowsPerPage: 10,
      totalRows: 0,
      searchTerm: '',
      searchTerm2: '',

      hovered: false,
      showOnboardingModal0: false,
      onboardButtonClicked: false,
      businessType: '',
      businessName: '',
      email: '',
      taxNumber: '',
      phoneNumber: '',
      userID: '',
      withData: true,
      isDropdownOpen: false,
      cardSwitch: 'Onboarded',
      tableData: [],
      onboardedData: [],
      pendingData:[],
      showPopup: Array(3).fill(false),
      
    };
  },

  async mounted() {
    this.userID = sessionStorage.getItem('userId');
    document.addEventListener('click', this.closePopups);

    try{
      await this.fetchPendingOnboard();
      await this.fetchAllOnboardedMerchants();
      this.fetchDataLoading = false;
    }catch(error){
      console.log(error);
    }
   
    if(this.onboardedData.length === 0 && this.pendingData.length > 0){
      this.tableData = this.pendingData;
      this.totalRows = this.tableData.length;
      this.cardSwitch = 'Pending';
    }else if(this.pendingData.length === 0 && this.onboardedData.length > 0){
      this.tableData = this.onboardedData;
      this.totalRows = this.tableData.length;
    }else if(this.pendingData.length > 0 && this.onboardedData.length > 0){
      this.tableData = this.onboardedData;
      this.totalRows = this.tableData.length;
    }else {
      this.withData = false;
    }
  },

  computed: {
    displayedData() {
      return this.cardSwitch === 'Pending' ? this.pendingData : this.onboardedData;
    },
    disableDropdown() {
      // Disable dropdown if one of the data arrays is empty
      return this.onboardedData.length === 0 || this.pendingData.length === 0;
    },

    filteredRows() {
  let filteredData = [];
  let startIndex = 0;
  let endIndex = 0;

  if (this.cardSwitch === 'Onboarded') {
    const term = this.searchTerm.toLowerCase().trim();
    if (!term) return this.tableData;

    // Filter rows based on search term
    filteredData = this.tableData.filter(row =>
      Object.values(row).some(value =>
        value && value.toString().toLowerCase().includes(term)
      )
    );

    // Apply pagination to filtered rows
    startIndex = (this.currentPage - 1) * this.rowsPerPage;
    endIndex = startIndex + this.rowsPerPage;
  } else if (this.cardSwitch === 'Pending') {
    if (!this.pendingData) return filteredData; // Handle null or undefined case

    const term = this.searchTerm2.toLowerCase().trim();
    if (!term) return this.pendingData;

    // Filter rows based on search term
    filteredData = this.pendingData.filter(row =>
      Object.values(row).some(value =>
        value && value.toString().toLowerCase().includes(term)
      )
    );

    // Apply pagination to filtered rows
    startIndex = (this.currentPage - 1) * this.rowsPerPage;
    endIndex = startIndex + this.rowsPerPage;
  }

  return filteredData.slice(startIndex, endIndex);
},



    visibleRows() {
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    const endIndex = startIndex + this.rowsPerPage;
    
    // Filter rows based on search term
    const filteredRows = this.filteredRows;
    
    // Slice the filtered rows based on pagination
    return filteredRows.slice(startIndex, endIndex);
  },
  currentPageStart() {
    if (this.searchTerm || this.searchTerm2) {
      return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.filteredRows.length);
    } else {
      return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.totalRows);
    }
  },

  currentPageEnd() {
    if (this.searchTerm || this.searchTerm2) {
      return Math.min(this.currentPage * this.rowsPerPage, this.filteredRows.length);
    } else {
      return Math.min(this.currentPage * this.rowsPerPage, this.totalRows);
    }
  }
  },

  methods: {

    navigateToDetails(row) {
    if (row.merchantId) {
      this.$router.push({
        path: '/sales/business/details',
        query: { MID: row.merchantId }
      });
    }
  },

    async fetchAllOnboardedMerchants() {
      document.body.style.overflow = 'auto';
    try {
      const response = await axios.get(`${this.$config.GETMERCHANT_ENDPOINT}/${this.userID}`);
     
      this.onboardedData = response.data.data;
      console.log('Value is for onborded',  this.onboardedData);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  },

  closeOnboardingModal0() {
      this.showOnboardingModal0 = false;
      document.body.style.overflow = 'auto';
    },

    closeOnboardingModal1() {
      this.onboardButtonClicked = false;
      this.showOnboardingModal0 = false;
      document.body.style.overflow = 'auto';
    },

    openOnboardingModal1() {
      this.onboardButtonClicked = true;
      document.body.style.overflow = 'hidden';
    },

    openOnboardingModal0() {
      this.showOnboardingModal0 = true;
      this.onboardButtonClicked = true;
      document.body.style.overflow = 'hidden';
     
    },

    openContinueModal(rowData) {
      this.selectedRowData = rowData; 
      this.showOnboardingModal0 = true;
      this.onboardButtonClicked = true;
      document.body.style.overflow = 'hidden';
    },
    async closeContinueModal() {
      this.fetchPendingOnboard()
      this.showOnboardingModal0 = false;
      this.onboardButtonClicked = false;
      document.body.style.overflow = 'auto';
    },

    formatDate(dateTimeString) {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits for day
    const month = date.toLocaleString('en-US', { month: 'short' }); // Get short month name
    const year = date.getFullYear().toString(); // Get full year

    // Concatenate day, month, and year with hyphens
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
},

    async fetchPendingOnboard() {
      document.body.style.overflow = 'auto';
      const token = sessionStorage.getItem('token');
    try {
      const response = await axios.get(`${this.$config.GETPENDINGONBOARD_ENDPOINT}/${this.userID}`,
      {
        headers: {
          Authorization: `Bearer ${token}` 
        }
      });
     
      this.pendingData = response.data.onboardingData;
      console.log('Value is',  this.pendingData);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  },

    handleCardSwitch() {
     if(this.cardSwitch == 'Onboarded'){
       this.tableData = this.onboardedData;
       this.searchTerm2 = '';
       this.totalRows = this.tableData.length;
     } else if(this.cardSwitch == 'Pending'){
      this.tableData = this.pendingData;
      this.searchTerm = '';
      this.totalRows = this.tableData.length;
     }
    },

    nextPage() {
    const totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
  },
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  },



    toggleHover() {
            this.hovered = !this.hovered;
          
        },

        togglePopup(row) {
          this.tableData.forEach(row => {
        row.showPopup = false;
      });
          console.log('popup clicked', row);
    // Check if the row already has the showPopup property
    if (!Object.prototype.hasOwnProperty.call(row, 'showPopup')) {
      // If not, add it with an initial value of false
      this.$set(row, 'showPopup', false);
    }
    // Toggle the showPopup value for the corresponding row
    row.showPopup = !row.showPopup;
  },


    closePopups() {

      console.log('Close popup clicked');
      // Close all popups
      this.tableData.forEach(row => {
        row.showPopup = false;
      });
    },

   

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        this.$refs.dropdown.focus();
      }
    },

    
   
  },
  
  };
  </script>
  
  <style>

.loader {
  width: auto;
  height: 30px;
  margin-top: 220px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #6F48FF;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}
@keyframes l20-1{
   0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
   12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
   25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
   50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
   100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{ 
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}

  
  </style>
  